import { ReactNode, useMemo } from 'react';

import { CssBaseline, ThemeProvider } from '@mui/material';

import { createTimelogTheme } from '@/assets/themes/createTimelogTheme';
import { useLocaleStore } from '@/stores/locale';

import type {} from '@mui/x-data-grid-pro/themeAugmentation';

export const TimelogThemeProvider = ({ children }: { children: ReactNode }) => {
  const currentLocale = useLocaleStore((state) => state.locale);

  const timelogTheme = useMemo(
    () =>
      createTimelogTheme(
        currentLocale.mui,
        currentLocale.dataGrid,
        currentLocale.pickers,
      ),
    [currentLocale],
  );

  return (
    <ThemeProvider theme={timelogTheme} noSsr defaultMode="light">
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
